/**
 * Actions for mail
 */
export const actions = {
  /**
   * Fetching the emails
   *
   * @param context
   * @param boxType
   * @returns {Promise<*>}
   */
  async loadEmails(context, {type, folderId}) {
    if((folderId > 0) && ('custom' === type) && !(context.state.emails[type][folderId])) {
      context.commit("createNewPersonalFolder", folderId);
    }

    let limit = 10;
    let isFav = context.getters.getFavouriteMode ? 1 : 0;
    let boxItem = context.state.emails[type];

    let boxType = -1;
    if('inbox' === type) {
      boxType = 1;
    } else if('sent' === type) {
      boxType = 2;
    } else if('unread' === type) {
      boxType = 4;
    } else if('custom' === type) {
      boxType = 5;
      boxItem = context.state.emails[type][folderId];
    } else if('draft' === type) {
      boxType = 0;
    } else if('trash' === type) {
      boxType = 3;
    }

    let pageNo = boxItem['page'];
    let additionalOffset = boxItem['additionalOffset'];

    context.commit("setMailVal", {
      boxType: type,
      folderId: folderId,
      key: 'loading',
      value: true
    });

    let appUserId = context.getters.getSelectedUserId;

    const json = await context.dispatch(
      "makeAuthRequest",
      {
        url: `portalemail/getall/${appUserId}/${boxType}/${folderId}/${pageNo}/${additionalOffset}/${isFav}/${context.rootGetters.getSelectedProviderID}`,
        method: "GET",
        chat: true
      },
      {
        root: true
      }
    );

    if (!json.error) {
      context.commit("setEmails", {
        emailList: json.mail,
        boxType: type,
        folderId: folderId
      });

      context.commit("setMailVal", {
        boxType: type,
        folderId: folderId,
        key: 'page',
        value: pageNo + 1
      });

      context.commit("setMailVal", {
        boxType: type,
        folderId: folderId,
        key: 'isFewPagesLoaded',
        value: true
      });

      if (json.mail.length < limit) {
        context.commit("setMailVal", {
          boxType: type,
          folderId: folderId,
          key: 'isAllPagesLoaded',
          value: true
        });
      }
    }

    context.commit("setMailVal", {
      boxType: type,
      folderId: folderId,
      key: 'loading',
      value: false
    });

    return json;
  },

  /**
   * Fetching the inbox/unread mail count
   *
   * @param context
   * @returns {Promise<*>}
   */
  async fetchMailCount(context) {
    let isFav = context.getters.getFavouriteMode ? 1 : 0;
    let appUserId = context.getters.getSelectedUserId;

    const json = await context.dispatch(
      "makeAuthRequest",
      {
        url: `portalemail/getInboxUnreadMailCount/${appUserId}/${isFav}/${context.rootGetters.getSelectedProviderID}`,
        method: "GET",
        chat: true
      },
      {
        root: true
      }
    );

    if(!json.error) {
      if(!isFav) {
        context.commit("setUnreadMailIds", {
          setForOtherPage: 0 === appUserId,
          mailIds: json.unreadMailIds
        });
      }

      context.commit("setBoxCount", {
        key: 'unread',
        value: json.unreadMailIds.length
      });

      context.commit("setBoxCount", {
        key: 'inbox',
        value: json.inboxCount
      });

      context.commit("setBoxCount", {
        key: 'needLoad',
        value: false
      });
    }

    return json;
  },

  /**
   * Function to load the folder list
   *
   * @param context
   * @returns {Promise<*>}
   */
  async loadFolderList(context) {
    let appUserId = context.getters.getSelectedUserId;
    const json = await context.dispatch(
      "makeAuthRequest",
      {
        url: `portalemail/loadFolderList/${appUserId}/${context.rootGetters.getSelectedProviderID}`,
        method: "GET",
        chat: true
      },
      {
        root: true
      }
    );

    if(!json.error) {
      context.commit("setEmailFolder", json.emailFolder);
    }

    return json;
  },

  /**
   * Request to fetch all contacts of logged-in user
   *
   * @param context
   * @returns {Promise<void>}
   */
  async fetchAllContacts(context) {
    let appUserId = context.getters.getSelectedUserId;
    const json = await context.dispatch(
        "makeAuthRequest",
        {
            url: `portalemail/getContactList/${appUserId}/${context.rootGetters.getSelectedProviderID}`,
            method: "GET",
            chat: true
        },
        {
            root: true
        }
    );

    if(!json.error) {
      context.commit("setContactList", json.contactList);
      context.commit("setSignatures", json.signatures);
    }

    return json;
  },

  /**
   * Request to remove a file
   *
   * @param context
   * @param fileId
   * @returns {Promise<*>}
   */
  async removeAttachment(context, { fileId }) {

    // Remove the file
    const json = await context.dispatch(
      "makeAuthRequest",
      {
        url: "portalemail/deleteFile/" + fileId,
        method: "DELETE",
        chat: true,
        data: {
          selectedSubscriberId: context.rootGetters.getSelectedProviderID,
          appUserId: context.getters.getSelectedUserId
        }
      },
      {
        root: true
      }
    );

    return json;
  },

  /**
   * Request to check if user is on contact list of another user
   *
   * @param context
   * @param userId
   * @returns {Promise<*>}
   */
  async checkUserContact(context, {userId, isGroup}) {
    return await context.dispatch(
      "makeAuthRequest",
      {
        url: `email/checkUserContact/${userId}/${isGroup}`,
        method: "GET",
        chat: true
      },
      {
        root: true
      }
    );
  },

  /**
   * Request to load a mail detail
   *
   * @param context
   * @param fileId
   * @returns {Promise<*>}
   */
  async loadMailDetail(context, { mailId, mailType }) {

    let appUserId = context.getters.getSelectedUserId;
    // Remove the file
    const json = await context.dispatch(
      "makeAuthRequest",
      {
        url: `email/getContent/${appUserId}/${mailId}/${mailType}/${context.rootGetters.getSelectedProviderID}`,
        method: "GET",
        chat: true
      },
      {
        root: true
      }
    );

    return json;
  }
};
